<template>
    <div>
        <TheHeader class="mob-header" />
        <BaseTitle :infor="infor" />
        <BaseListUlmoudle2 
            class="product-list-ul" 
            :list="list" 
        />
        <TheFooter class="mob-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseListUlmoudle2 from '@/components/module/BaseListUlmoudle2'

    // import jquery from 'jquery'

    import '@/assets/less/module/module-base-list-ulmoudle2_product-list-ul.less'

    export default {
        name: 'MobProduct',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseListUlmoudle2
        },
        computed: {
            infor: function(){
                let infor = this.json.infor;
                return infor;
            },
            list: function(){
                let json = JSON.parse(JSON.stringify(this.json)); 
                let list = json.list;
                for(let i=0, l=list.length; i<l; i++){
                   var arr = list[i].data;
                   for(let j=0, n=arr.length; j<n; j++){
                        if(arr[j].type === 'image') {
                            arr[j].src = arr[j].mobSrc;
                        }
                   }
                }
                return list;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.title-box {
    padding-bottom: .32rem;
}
</style>